import WSApiHandlerService from "./ws-api-handler-service";

export default class WSApi {
    static ws = new WSApiHandlerService();
}